/* RESPONSIBLE TEAM: team-proactive-support */
import type Node from './node';
import Coordinates, { type CoordinateLike } from './coordinates';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { computed } from '@ember/object';
import { tracked } from '@glimmer/tracking';

type Alignment = 'left' | 'right' | 'top' | 'bottom' | 'no-alignment';
type Direction = 'inwards' | 'outwards' | 'both';

interface ConnectionPointInputs<DataObjectType = any> {
  x: number;
  y: number;
  alignment: Alignment;
  direction: Direction;
  dataObject?: DataObjectType;
}

export { ConnectionPointInputs, Alignment, Direction };

export default class ConnectionPoint<DataObjectType = any> implements CoordinateLike {
  @tracked x: number;
  @tracked y: number;
  @tracked alignment: Alignment;
  direction: Direction;
  @tracked node: Node;
  dataObject?: DataObjectType;

  constructor(
    x: number,
    y: number,
    alignment: Alignment,
    direction: Direction,
    node: Node,
    dataObject?: DataObjectType,
  ) {
    this.x = x;
    this.y = y;
    this.alignment = alignment;
    this.direction = direction;
    this.node = node;
    this.dataObject = dataObject;
  }

  @computed('alignment', 'node.bounds.{bottom,top}', 'y')
  private get top(): number {
    if (this.alignment === 'bottom') {
      return this.node.bounds.bottom + this.y;
    } else {
      return this.node.bounds.top + this.y;
    }
  }

  @computed('alignment', 'node.bounds.{left,right}', 'x')
  private get left(): number {
    if (this.alignment === 'right') {
      return this.node.bounds.right + this.x;
    } else {
      return this.node.bounds.left + this.x;
    }
  }

  @computed('left', 'top')
  get coordinates(): Coordinates {
    return new Coordinates(this.left, this.top);
  }

  asCoordinates() {
    return this.coordinates;
  }
}
